module.exports = __webpack_public_path__ + "img/home_yunfeishixiaochaxun_hover.59fe307.png";